/**
 * ファイルがaccept属性に指定された拡張子に一致するか確認する
 * @param {File} file
 * @param {string} accept (e.g. ".gif,.jpg,.jpeg,.png,.heic,.webp")
 */
export const isValidType = (file, accept) => {
  if (!accept) return true;
  const filename = file.name.toLowerCase();
  return accept.split(",").some((type) => {
    if (type === "*") {
      return true;
    } else if (type.startsWith(".")) {
      // 拡張子
      return filename.endsWith(type.toLowerCase());
    }
    // 謎の形式
    return file.type === type;
  });
};

/**
 * 拡張子のリストからピリオドを除いて大文字でスラッシュ区切りにする
 * .jpgと.jpegがあればJPGだけを残す
 * @param {string} accept
 * @returns {string}
 */
export const acceptListToString = (accept) => {
  return accept
    .split(",")
    .map((ext) => ext.trim().replace(/^\./, "").toUpperCase())
    .map((ext) => (ext === "JPEG" ? "JPG" : ext)) // JPEGをJPGに変換
    .filter((ext, index, self) => self.indexOf(ext) === index) // 重複を除去
    .join(" / ");
};
